import React from 'react';
import { useSelector } from 'react-redux';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Loading } from '../../../CommonComponents/OPL/Loading/Loading';
import { selectHasFirmSettingsAccess } from '../../../CommonSelectors/CommonAreaSelector';
import { useWidgetsQuery } from '../../api/useWidgetsQuery';
import { TabSlug } from '../../types';
import { DesktopWidgetsEmpty } from './DesktopWidgets.empty';
import { Widgets } from './components/Widgets/Widgets';
import { EditWidgets } from './components/EditWidgets/EditWidgets';
import { useFeatureFlag } from '../../../_hooks/useFeatureFlag';
import { Feature } from '../../../CommonSelectors/CommonArea.types';

interface Props {
  tab: TabSlug;
}

export const DesktopWidgets = ({ tab }: Props) => {
  const { isLoading, isError, refetch, data, dataUpdatedAt: widgetsUpdatedAt } = useWidgetsQuery({
    tab,
  });

  const areCustomTemplatesEnabled = useFeatureFlag(Feature.ShowCustomPersonalTemplates);

  const isFirmLevelUser = useSelector(selectHasFirmSettingsAccess);

  if (isLoading) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" mt={100}>
        <Loading />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" mt={100}>
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  if (data.included.length === 0) {
    return <DesktopWidgetsEmpty tab={tab} widgets={data} isFirmLevelUser={isFirmLevelUser} />;
  }

  if (isFirmLevelUser && !areCustomTemplatesEnabled) {
    return (
      <EditWidgets
        // Use the key to re-render the component and update its internal state
        key={`widgets-${widgetsUpdatedAt}`}
        tab={tab}
        widgets={data}
      />
    );
  }

  return <Widgets widgets={data} />;
};
